import {
  Box,
  Button, // Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { GifColors } from "../../../../theme";
import { SuggestedReviewers } from "../Icon";
import ProposalTable from "./ProposalTable";
import GradeAndRank from "./gradeAndRank/GradeAndRank";
import { useEffect, useState } from "react";
import SuggestedReviewer from "./SuggestedReviewer";
import { useSelector } from "react-redux";
import {
  advisorSelector,
  isCoordinatorSelector,
} from "../../../../store/advisorSlice";
import AssignAdvisorDialog from "./AssignAdvisorDialog";
import service from "../../Helpers/gifservices";
import { useLoading } from "../../../../providers/loadingProvider";
// import { useNotify } from "../../../../providers/NotificationProvider";
import RefereesStatus from "../RefereesStatus";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { refereeStatus } from "../../Constants";

// const JOINT_PUBLICATION_FILE_NAME = "propjointpub";

const StyledSwitch = withStyles({
  switchBase: {
    "&$checked": {
      color: "#00A14B",
    },
    "&$checked + $track": {
      backgroundColor: "#00A14B",
    },
  },
  checked: {},
  track: {},
})(Switch);

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 30,
    marginBottom: 50,
  },
  proposalName: {
    marginLeft: 10,
    fontWeight: 600,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  suggestButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    fontWeight: 500,
    marginLeft: 4,
  },
  button: {
    color: theme.palette.gif.blue.color,
    backgroundColor: "inherit",
    fontSize: 13,
    fontWeight: 500,
    marginLeft: 4,
  },
  switch: {
    marginRight: 10,
    float: "right",
  },
  infoRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 5,
  },
  info1: {
    fontColor: GifColors.generalBlack,
    fontWeight: 400,
    marginRight: 10,
  },
  info2: {
    fontColor: GifColors.generalBlack,
    fontWeight: 500,
    marginRight: 30,
  },
  addApplicantButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.green.hover,
    },
    color: theme.palette.gif.green.color,
    backgroundColor: theme.palette.gif.green.background,
    float: "right",
    marginRight: 10,
  },
  keepTogether: {
    pageBreakInside: "avoid",
  },
}));

export default function ProposalAdvisor(props) {
  const classes = useStyles();
  const {
    proposal,
    totalProposalsNumber,
    advisorTotalProposalNumber,
    AssignProposalToMe,
    refreshProposals,
  } = props;

  const loading = useLoading();
  // const notify = useNotify();
  const advisor = useSelector(advisorSelector);
  const isCoordinator = useSelector(isCoordinatorSelector);
  const [assignToMe, setAssignToMe] = useState(false);
  const [suggestReviewersOpen, setSuggestReviewersOpen] = useState(false);
  const [RefereesStatusOpen, setRefereesStatusOpen] = useState(false);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);

  // const CheckPublicationExist = async () => {
  //   const proposalId = proposal.id;
  //   if (!proposalId) return;
  //   const loadingId = loading.addLoading("fetching data");
  //   var files = await service.getProposalFiles({ proposalId });
  //   const publication = files.filter(
  //     (f) => f.name === `${proposalId}_${JOINT_PUBLICATION_FILE_NAME}`
  //   );
  //   loading.removeLoading(loadingId);
  //   if (publication.length > 0) return true;
  //   notify.show(`Proposal Dont Have Publication File!`, { severity: "error" });
  //   return false;
  // };

  // const getProposalPublications = async () => {
  //   const proposalId = proposal.id;
  //   const loadingId = loading.addLoading("Downloading Publications");
  //   var data = await service.downloadProposalFiles({
  //     id: proposalId,
  //     fileName: JOINT_PUBLICATION_FILE_NAME,
  //   });
  //   if (!(data instanceof Blob)) {
  //     return;
  //   }
  //   const blob = new Blob([data], { type: "application/pdf" });
  //   const link = document.createElement("a");
  //   link.href = window.URL.createObjectURL(blob);
  //   link.download = `Publication.pdf`;
  //   link.click();
  //   loading.removeLoading(loadingId);
  // };

  // const DownloadPublication = async () => {
  //   if (await CheckPublicationExist()) getProposalPublications();
  // };

  const createPDF = async () => {
    const proposalId = proposal.id;
    if (!Boolean(proposalId)) return;
    const loadingId = loading.addLoading("Downloading Proposal Info");
    const pdfPath = await service.createProposalPDF({ proposalId });
    await service.downloadRawFile({
      path: pdfPath,
      filename: proposal.name,
    });
    loading.removeLoading(loadingId);
  };

  useEffect(() => {
    if (advisor.id === proposal?.proposalAdvisors[0]?.advisorId) {
      setAssignToMe(true);
    }
  }, [advisor, proposal]);

  return (
    <Box className={classes.keepTogether}>
      <RefereesStatus
        open={RefereesStatusOpen}
        onClose={() => setRefereesStatusOpen(false)}
        proposal={proposal}
      />
      <Modal
        open={suggestReviewersOpen}
        onClose={() => setSuggestReviewersOpen(false)}
      >
        <Box>
          <SuggestedReviewer
            proposalId={proposal.id}
            openCloseSuggestedReviewers={() => setSuggestReviewersOpen(false)}
          />
        </Box>
      </Modal>
      <Grid container className={classes.root}>
        <Grid
          item
          xs={7}
          style={{
            display: "flex",
            flexDirection: "row",
            color: GifColors.generalBlack,
          }}
        >
          <IconButton
            color="inherit"
            onClick={createPDF}
            style={{ paddingTop: 0, paddingRight: 0 }}
            size="large"
          >
            <CloudDownloadIcon />
          </IconButton>
          <div>
            {/* <Typography className={classes.proposalName}>
              {proposal.name}
            </Typography> */}
            <Typography className={classes.proposalName}>
              {proposal.title || "No Title"}
            </Typography>
          </div>
        </Grid>
        <Grid
          item
          xs={5}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            size="small"
            disableElevation
            variant="contained"
            className={classes.button}
            onClick={() => setRefereesStatusOpen(true)}
          >
            Reviewers Status
          </Button>
          {/* <Button
            size="small"
            disableElevation
            variant="contained"
            className={classes.button}
            onClick={DownloadPublication}
          >
            Publications
          </Button> */}
          <Button
            size="small"
            disableElevation
            variant="contained"
            className={classes.suggestButton}
            startIcon={<SuggestedReviewers />}
            onClick={() => setSuggestReviewersOpen(true)}
          >
            Suggest Reviewers
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Grid container>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Applicants - Institution</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* PI  Only */}
                    {proposal.applicants.filter(a=> a.pici === 1).map((a,i) => (
                      <TableRow>
                        <TableCell>{i+1}. {a.name} - {a.institutionName}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Box>
        </Grid>
        <Box width="99%" bgcolor="#FBFAFA" paddingBottom={2} borderRadius="8px">
          <Grid container>
            <Grid item xs={12}>
              <Box>
                <Grid container>
                  <Grid item xs={7}>
                    <ProposalTable
                      proposalRefrees={proposal.proposalRefrees.filter(
                        (pr) =>
                          pr.statusCode ===
                          refereeStatus.evaluationReceivedFromReferee
                      )}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <GradeAndRank
                      proposal={proposal}
                      totalProposalsNumber={totalProposalsNumber}
                      advisorTotalProposalNumber={advisorTotalProposalNumber}
                      refreshProposals={refreshProposals}
                      assignToMe={assignToMe}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12}>
              {proposal?.proposalAdvisors.length > 0 ? (
                <Box display="flex" style={{ float: "right" }} margin={1}>
                  <Typography className={classes.info1}>
                    Proposal is assign to:
                  </Typography>
                  <Typography className={classes.info2}>
                    {proposal.proposalAdvisors[0].name}
                  </Typography>
                </Box>
              ) : isCoordinator ? (
                <>
                  <Button
                    variant="contained"
                    className={classes.addApplicantButton}
                    onClick={() => setAssignDialogOpen(true)}
                    disabled={proposal?.proposalAdvisors.length > 0}
                    disableElevation
                  >
                    Assign Advisor To Proposal
                  </Button>
                  <AssignAdvisorDialog
                    open={assignDialogOpen}
                    onClose={() => setAssignDialogOpen(false)}
                    proposalId={proposal.id}
                    refreshProposals={refreshProposals}
                  />
                </>
              ) : (
                <FormControlLabel
                  className={classes.switch}
                  control={
                    <StyledSwitch
                      checked={assignToMe}
                      onChange={() => AssignProposalToMe(proposal.id)}
                      // disabled={proposal?.proposalAdvisors.length > 0}
                    />
                  }
                  label="Assign to me"
                  labelPlacement="start"
                />
              )}
            </Grid>
            <Grid item xs={12} style={{ marginTop: 5 }}>
              <Divider />
            </Grid>
            <Grid item className={classes.infoRow}>
              <Typography className={classes.info1}>Resubmission</Typography>
              <Typography className={classes.info2}>
                {proposal.resubmission ? "Yes" : "No"}
              </Typography>
              <Typography className={classes.info1}>
                Previous Proposal
              </Typography>
              <Typography className={classes.info2}>
                {proposal.previousProposalName || "- - -"}
              </Typography>
              <Typography className={classes.info1}>Continuation</Typography>
              <Typography className={classes.info2}>
                {proposal.continuation ? "Yes" : "No"}
              </Typography>
              <Typography className={classes.info1}>Previous Grant</Typography>
              <Typography className={classes.info2}>
                {proposal.previousGrantName || "- - -"}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
}
